import React, { useState, useEffect } from 'react'
import { Button, ButtonBase, Checkbox, FormControlLabel, Grid, IconButton, MenuItem, Select, FormLabel, FormControl, FormGroup, FormHelperText } from '@material-ui/core';
import './style.css';
import CustomDialog from './Dialog';
import ProductConfigDialog from './ProductConfigDialog/Mobile';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { CSSTransition } from 'react-transition-group';
import AnimateHeight from 'react-animate-height';

const Mobile = (props) => {
  const queryParams = new URLSearchParams(window.location.search);
  let anyrace_show_popup = false;
  if (queryParams.get('anyrace_show_popup')){
    anyrace_show_popup = true;
  }
  const [modalOpen, setModalOpen] = useState(anyrace_show_popup);
  const [cartridge, setCartridge] = useState(null);
  const [productsConfigs, setProductsConfigs] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const { productType, isMobile, product: detail } = props;
  const [upgradeKit, setUpgradeKit] = useState('');
  const [suspension, setSuspension] = useState('');
  let variations = detail.variations || [];
  console.log('Variations mobile', variations);
  const [variationsTravel, setVariationsTravel] = useState(null);
  console.log('Variations Travel mobile', variationsTravel);

  useEffect (() => {
    console.log('The cartridge state mobile', cartridge);
  }, [cartridge]);

  // Initially set variationsTravel-value when product has variations
  useEffect (() => {
    setVariationsTravel(variations);
  }, [variations]);

  let HelperArray = [];

  variations.map(variationTravel => {
    let VariationTravelObject = variationTravel.attributions_object;
    let key = VariationTravelObject["upgrade-kit"];
    if (!HelperArray.includes(key)){
      HelperArray[key] = [];
    }
  })
  variations.map(variationTravel => {
    let VariationTravelObject = variationTravel.attributions_object;
    console.log('VariationsTravel Objekt mobile', VariationTravelObject);
    let key = VariationTravelObject["upgrade-kit"];
    if (HelperArray.hasOwnProperty(key)){
      HelperArray[key].push(variationTravel);
    }
  })
  console.log('Helper Array mobile', HelperArray);

  let productTags = Object.values(detail.theTags) || [];

  // Storing a product's any cross-sells-product in an array, for use in checkbox-component
  let crossSells = detail.crossSells || [];
  console.log(crossSells);
  let crossSellsValues = Object.values(crossSells);
  console.log(crossSellsValues);
  let countCrossSellsValues = crossSellsValues.length;
  console.log('ARRAYLENGTH mobile', countCrossSellsValues);

  const [model, setModel] = useState(null);
  const [price, setPrice] = useState(detail.price || 0);
  const [crosssells, setCrosssells] = useState(detail.crossSells || []);
  console.log("product-options mobile", variations, cartridge?.id, detail?.id);
  const [expand, setExpand] = useState(true);
  /*const [state, setState] = React.useState({
    crosssales: false,
    upsales: false,
    //antoine: false,
  });*/
  //const { crosssales } = state;


  const [checked, setChecked] = useState(false);
  const {isChecked} = checked;
  const [crosssellsCheckedId, setCrosssellsCheckedId] = React.useState([]);
  const {checkedIds} = crosssellsCheckedId;

  const handleCheckboxChange = (event) => {

    // Inverting the checkbox's current state at time of click
    setChecked(!checked);

    const checkedOnes = crosssellsCheckedId;

    // When target-checkbox is getting checked ('true'), cross-sells-id from name attribute is written in state-array
    if (event.target.checked === true) {
      setCrosssellsCheckedId([...checkedOnes, event.target.name]);
    }

    // When target-checkbox is getting unchecked ('false'), cross-sells-id from name attribute is erased in state-array
    if (event.target.checked === false) {
      const index = checkedOnes.indexOf(event.target.name);
      if (index !== -1) {
        checkedOnes.splice(index, 1);
        setCrosssellsCheckedId(checkedOnes);
      }
    }
  };

  // Effect hook for checking the array holding the checked cross-sells-ids, used due to state asynchronicity
  useEffect(() => {
    console.log('THECHECKEDIDS mobile', crosssellsCheckedId);
  }, [crosssellsCheckedId]);


  // Checked Crosssells-ids array-mapping, comma-separated
  var crosssellsArray = crosssellsCheckedId.map(function(item, index){

    // Add prepended comma, to separate it from prodID in cart query string
    let separatingComma = '';
    if( index === 0){
      separatingComma = ',';
    }
    return separatingComma + item;
    //return(e);
  })
  console.log('LISTUNG mobile', crosssellsArray);

  //var crosssellsQueryString = crosssellsArray.join(',');
  //console.log('STRINGIFIED', crosssellsQueryString);

  let processingTimes = detail.processingTimes || [];
  let processingTimesValues = Object.values(processingTimes);
  //console.log(processingTimesValues);
  let pt_product_instock = '';
  let pt_product_outofstock = '';
  let pt_productVariant_instock = '';
  let pt_productVariant_outofstock = '';
  if ( processingTimesValues.length !== 0 ){
    //console.log(processingTimesValues.length);
    pt_product_instock = processingTimesValues[0];
    pt_product_outofstock = processingTimesValues[1];
    pt_productVariant_instock = processingTimesValues[2];
    pt_productVariant_outofstock = processingTimesValues[3];
    console.log(pt_product_instock,pt_product_outofstock,pt_productVariant_instock,pt_productVariant_outofstock);
  }

  function addToCart() {

    let prodID;
    if (!cartridge) {
      prodID = detail.id;
      console.log('Cartridge Detail mobile:', detail.id);
    } else {
      prodID = cartridge.id
      console.log('Cartridge Cartridge mobile:', cartridge.id);
    }
    if (productType !== "service" && model) {
      prodID = model.id;
      console.log('Cartridge Model mobile:', model.id);
    }
    if (productType === "service" && productTags.includes('travel') && model) {
      prodID = model.id;
      console.log('Cartridge Model Travel mobile:', model.id);
    }

    let queryString = '';
    if (productsConfigs) {
      queryString = "&" + (new URLSearchParams(productsConfigs).toString());
    }

    console.log(`/?add-to-cart=${prodID}&quantity=${quantity}${queryString}`);
    var url = window.location.href.split('?')[0];
    console.log("URL mobile", url);
    //window.location.href = `${url}?add-to-cart=${prodID}&quantity=${quantity}${queryString}&fromR=1&cs=${JSON.stringify(state)}`;
    window.location.href = `${url}?add-to-cart=${prodID}${crosssellsArray}&quantity=${quantity}${queryString}&fromR=1`;
  }

  // Effect hook for checking the complete cart-url-string
  useEffect (() => {
    console.log('THECOMPLETEURL mobile', window.location.href);
  });

  useEffect(() => {
    //console.log('cs1: '+crosssells);

    // show Cart on load if fromR is set
    //field "search";
    var pattern = /[?&]fromR=/;
    var URL = window.location.search;

    if(pattern.test(URL)) {
      const cart = document.querySelectorAll(`.elementor-menu-cart__container.elementor-lightbox`);
      cart?.forEach((item, index) => {
        cart[index].classList.add("elementor-menu-cart--shown");
      })
      const url = window.location.href.split('?')[0];
      window.history.pushState({}, null, url);
      console.log("fromR=1 found!",);
      // alert("Found");
    }else{
        console.log("fromR Not found!");
    }
    ///////////////////////

    setCartridge(null);
    setProductsConfigs(null);
    if (detail && detail.variations.length > 0) {
      setModel(detail.variations[0]);
      console.log('MODEL mobile', detail.variations[0]);
    } else {
      setModel(null);
    }
    setPrice(props.product.price * quantity);
    console.log("PRODCUT-OPTION-EFFCET mobile", props.product, quantity);
  }, [props.product])

  const handleChange = (event) => {
    setQuantity(event.target.value);
  };


  useEffect(() => {
    console.log("Price mobile", model, quantity, cartridge);
    console.log('Aktuelles Model mobile', model);
    let productPrice = 1;
    if (model) {
      productPrice = quantity * model.price;
      setPrice(productPrice);

      setCrosssells(model.crossSells);
      //setCrosssells(crossSells);
      //console.log('cs0: '+ JSON.stringify(model));
      console.log('cs2 mobile : '+crosssells);
    }

    if (cartridge) {
      console.log('THE ID mobile', cartridge.id);
      const selectedVariant = variations.filter((v) => v.id === cartridge.id);
      console.log("selectedVariant-cartridge mobile", selectedVariant[0]);
      productPrice = quantity * selectedVariant[0].price;
      console.log("PPPP mobile", quantity, productPrice, selectedVariant[0].price);
      setPrice(productPrice);
    }

    if (!model && !cartridge) {
      productPrice = quantity * props.product.price;
      setPrice(productPrice);
    }
    
  }, [model, quantity, cartridge]);

  const handleModelChange = (event) => {
    const selectedVariant = variations.filter((v) => v.id === event.target.value);
    setModel(selectedVariant[0]);
    console.log('Variant 0 mobile', selectedVariant[0]);
  };

  const handleExpandClick = (event) => {
    setExpand(!expand);
  }

  const handleUpgradeKitChange = (id, payload) => {
    let key = payload.props.children;
    console.log('Handler event key mobile', key);
    const selectedSuspension = HelperArray[key];
    console.log('AAAAAAA mobile', selectedSuspension);

    // Set second select back to default value "Bitte wählen" in case first select is used again
    if (suspension) {
      setSuspension('');
    }
    // Disable add-to-cart-button in case first select is used again
    if (cartridge) {
      setCartridge(null);
    }

    setUpgradeKit(selectedSuspension[0]);
    console.log('Upgrade Kit mobile', selectedSuspension[0]);
    setVariationsTravel(selectedSuspension);
    setModel(selectedSuspension[0]);
  }

  const handleSuspensionChange = (event) => {
    const selectedVariant = variations.filter((v) => v.id === event.target.value);
    setSuspension(selectedVariant[0]);
    setModel(selectedVariant[0]);
    console.log('Variant 0 mobile', selectedVariant[0]);
    setCartridge(model);
  };

  /// Enable Cart button
  let cartEnabled = false;
  if (productType === "service") {
    if (variations.length === 0) {
      cartEnabled = true
    } else if(cartridge) {
      cartEnabled = true
    }
  } else {

    if (productsConfigs) {
      cartEnabled = true;
    }
    if (variations.length > 0 && !model) {
      cartEnabled = false;
    }

    console.log("product-cartEnabled mobile", cartEnabled, model);
  }
  console.log("BUTTON mobile", cartEnabled);


  const VariationsDefault = (props) => {

    return (
        <>
          <Grid item xs={7}>
            <div className="model">Einbaulänge / Laufradgröße</div>
          </Grid>

          <Grid item xs={5}>
            <Select
                className="options-list"
                disableUnderline
                fullWidth
                value={model.id}
                onChange={handleModelChange}>
              {
                variations.map(variation => {
                  return (<MenuItem key={variation.id} value={variation.id}>{variation.model}</MenuItem>)
                })
              }
            </Select>
          </Grid>
        </>
    )
  }


  const VariationsTravel = (props) => {

    var UpgradeKitArray = [];

    return (
        <>
          <Grid item container direction="row" alignItems="center" justifyContent="space-between" xs={6}>
            <div className="model">1. Upgrade Kit</div>
            <Select
                className="options-list left"
                disableUnderline
                fullWidth
                value={upgradeKit.id}
                defaultValue={"placeholderl"}
                onChange={handleUpgradeKitChange}
            >
              <MenuItem value={"placeholderl"} style={{ opacity: 0.5, pointerEvents: 'none' }}>Bitte wählen</MenuItem>
              {
                variations.map(variation => {
                  let VariationObject = variation.attributions_object;
                  //console.log('Unser Objekt', VariationObject);
                  let VariationUpgradeKit = VariationObject["upgrade-kit"];
                  //console.log('UpgradeKit', VariationUpgradeKit);
                  if (!UpgradeKitArray.includes(VariationUpgradeKit)){
                    UpgradeKitArray.push(VariationUpgradeKit);
                    return (<MenuItem key={variation.id} value={variation.id}>{VariationUpgradeKit}</MenuItem>)
                  }
                })
                //console.log('Upgrade check Array', UpgradeKitArray);

              }
            </Select>
          </Grid>

          <Grid item container xs={5}>
            <div className="model">2. Federweg</div>
            <Select
                className="options-list right"
                disableUnderline
                fullWidth
                //value={model.id}
                value={suspension.id}
                defaultValue={"placeholderr"}
                onChange={handleSuspensionChange}
            >
              <MenuItem value={"placeholderr"} style={{ opacity: 0.5, pointerEvents: 'none' }}>Bitte wählen</MenuItem>
              {
                variationsTravel.map(variation => {
                  let VariationObject = variation.attributions_object;
                  let VariationSuspension = VariationObject["federweg"];
                  return (<MenuItem key={variation.id} value={variation.id}>{VariationSuspension}</MenuItem>)
                })
                //console.log('Federweg', VariationSuspension);

              }
            </Select>
          </Grid>
        </>
    )
  }

  return (
      <div className={`product-options`}>
      <AnimateHeight
        duration={ 500 }
        height={ expand ? 'auto' : 82 }
      >
        <div className="expand-icon" onClick={handleExpandClick}>
          { !expand ? <ExpandLessIcon /> : <ExpandMoreIcon /> }
      </div>
      <h3 className="option-name">{detail.name}</h3>
      {detail && (detail.length !== 0 ) && (
        <>
          {
            (productType === "service") ?
              (
                variations && variations.length > 0 && !productTags.includes('travel') && (
                  <Button className="options-dialog" onClick={() => setModalOpen(true)}>
                  { !cartridge ? 'Wahlen Sie ihr Modell/Kartusche aus' : cartridge.model}
                  </Button>
                )
              ) : (
                    !productTags.includes('travel') && (
                    <Button className="options-dialog" onClick={() => setModalOpen(true)}>
                      { !productsConfigs ? "Wähle dein Setup" : "Setup ✓" }
                    </Button>
                    )
              )
          }
          <div style={{ marginTop: '12px' }}>
              { variations.length > 0 && model ?
                <Grid container direction="row" alignItems="center" justifyContent="space-between">
                  {productType === "service" && productTags.includes('travel') && <VariationsTravel/>}
                  {productType !== "service" && <VariationsDefault/>}
                </Grid>
                : null
              }

            <div className="instructions">Bearbeitungszeit: {
              (productType === 'service' && model) && (detail.stock_status === "instock" ? pt_productVariant_instock : pt_productVariant_outofstock) ||
              (productType !== 'service' && model) && (model.stock_status === "instock" ? pt_product_instock : pt_product_outofstock) ||
              (detail.stock_status === "instock" ? pt_productVariant_instock : pt_productVariant_outofstock)
            }</div>
            <Grid container direction="row" alignItems="center" justifyContent="space-between">
                <Grid item>
                  <Select
                    className="options-list"
                    disableUnderline
                    value={quantity}
                    onChange={handleChange}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                  </Select>
                </Grid>
                <Grid item>
                  <p className="product-price">€ {price},-</p>
                </Grid>

              </Grid>
              <div className="instructions-two">Inkl. 19% MwSt. und Versandkosten</div>
              <Grid container direction="column" alignItems="flex-start" justifyContent="center" >
                {countCrossSellsValues !== 0 ? (
                  <div className="cross-sells">
                    <FormControl component="fieldset" className="crossells-formcontrol">
                    <FormLabel component="legend">Zusatz-Angebote:</FormLabel>
                      <FormGroup>
                        {crossSellsValues.map((crossSellsValue, index) => (
                            <FormControlLabel
                                control={<Checkbox checked={isChecked} onChange={handleCheckboxChange} name={crossSellsValue.id} />}
                                label={crossSellsValue.title + ' (' + crossSellsValue.price + '€)'}
                            />
                        ))}
                        {/*<FormControlLabel
                              control={<Checkbox checked={isChecked} onChange={handleCheckboxChange} name="upsales" />}
                              label={checkedIds}
                          />*/}
                      </FormGroup>
    {/*
                      <FormHelperText>Bei gewähltem Zusatz-Service: Rabatt wird im Warenkorb angezeigt</FormHelperText>
    */}
                    </FormControl>
                  </div>
                ) : ('')}

              </Grid>
              <Grid container direction="row" alignItems="center" justifyContent="center" >
                
                <Grid item>
                  <Button
                    className={`addToCart ${productTags.includes('travel') ? 'travel' : ''}`}
                    disabled={!cartEnabled}
                    onClick={addToCart}>
                    In den Warenkorb
                  </Button>
                </Grid>

              </Grid>
            </div>

            {
              productType === "service" ? (
                <CustomDialog
                  variations={variations}
                  setCartridgeCallback={setCartridge}
                  open={modalOpen}
                  handleClose={() => {
                    setModalOpen(false);
                  }}
                />
              ) : (
                  <ProductConfigDialog 
                    product={props.product}
                    setProductsConfigsCallback={setProductsConfigs}
                    open={modalOpen}
                    handleClose={() => {
                      setModalOpen(false);
                    }}
                  />
                )
              }
        </>
        )}
        
        </AnimateHeight>
    </div>
    
  
  
  );
}

export default Mobile;